var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_510_8654",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_510_8654",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAADgUlEQVR4nO3bO4hUVxzH8d9Zo0sSRS0UohuRYCwEQcFHKgMJpAmaIoXNthaSgI0EUkZQbBdDwNYiXRBFCwnIFrJJEU2KEOPCElAhRHzAxgdG2a/FXmH2zJ2dvXdmc/87+/vAFDNn5rx+nHvm3jsjmZmZmZmZmZmZmZmZmZkJWAV8CfwMPC4ePwFfAKua7t+yAmwCbtDZdeCdpvu5LBQrY74wXvsFWNl0fwdecZhaqKNN93fgFXtGq0vAZmAEuJyVTTTd34EH/JtN+khL2btZ2XSTfV0OEsCcF1JKrc+7lVt/DTXdAZvLgQTjQIJxIME4kGAcSDAOJBgHEowDCcaBBONAgnEgwTiQYBxIMA4kmDfqfhDYKOlDSfskbZP0vqRN2dvuSbop6Zaka5KuppSe1m1zWchvmncrB74GfgVmut+CbzMNfAdsa2KsS0KNQPrhP2AMWN3EmCOrfAu3z6YkHUop/bGIbSwpvQbySNK4pAlJf0r6S9KzomxI0oik9zS713wmaW1JHQ8lHUwplf6iBfhU0llJm7sNJrjHku5Kui7pvKSLKaUXbe/q4ZD1AHhzob0BhoFR4HZJXU+Ajzt87k7tA2Nsk8ChfgYCcHihgbTU9xZwtqSuh5Rs9r2PO7QZ4BQw1HHAFSfkxpzKqgVzjPZvar+TbfT9GPUScLJfgQAcqRNIUfdXJfWNzdd+3baaBrwN7AfOAM+zYc0AB1+/sWog49nze8C6Hjr6fVbfS2Bvp/brthMJsAu4mw3tFrCyTiC7i0lr9QNQ6xeNwFrgn6y+iZbygQtEkop5zFfK55UDKV47XRLUiR46d6Skvk86tT8ogG+z4Z2rG8gws5dPct9QY6UAK4DfsrrGO7U/KIAPsuHdrBVI8foW4O+SUM4DG2p0brSkrh0DHsiabHjTtQMpyvYwe4KYewQcB9ZU6NwwcD+rp+3Q2I+JiCQfX89/RwB2Sroiqew/iNOSLkj6UdKkpKmU0n1mz/DXS9oqaYekA5I+UvvlkUlJ2+drf6lrm9+qgdji8h3DYBxIMA4kmK731AdtE40m36O9QoJxIME4kGAcSDAOJBgHEowDCcaBBONAgul6pu6rvf3V7cqHV0gwDiQYBxJM5X9Q+epvNVX3YK+QYBxIMA4kGAcSjAMJpu1bls/MF1e3+fUKCcaBBONAzMzMzMzMzMzMzMzM7H/1Cg34AgFIrmmYAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatIcon);
export default __webpack_public_path__ + "static/media/FlatIcon.75fff695631d62e904f9d052175e669d.svg";
export { ForwardRef as ReactComponent };